import React from 'react';
import { Grid } from '@nextiva/next-ui-components';
import {
  SchedulesTable,
  SchedulesDrawer,
  useScheduleDrawerState,
  SchedulesForm,
} from '@nextiva/platform-schedules-lib';
import { Page } from 'containers';
import PageHeading from './components/SchedulePageHeading';

const Schedules = () => {
  const {
    drawerOpen,
    edit,
    closeDrawer,
    handleCreateNew,
    handleEditExisting,
    schedule,
    saveEnabled,
    saveValue,
    handleFormChange,
  } = useScheduleDrawerState();

  return (
    <Page title="Company schedules">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PageHeading />
        </Grid>
        <Grid item xs={12} mt={4}>
          <SchedulesTable
            schedulesLevel="Account"
            handleCreateNew={handleCreateNew}
            handleEditExisting={handleEditExisting}
          />
          <SchedulesDrawer
            open={drawerOpen}
            edit={edit}
            closeDrawer={closeDrawer}
            saveEnabled={saveEnabled}
            saveValue={saveValue}
            schedule={schedule}
          >
            <SchedulesForm
              schedule={schedule}
              scheduleType="COMPANY"
              valueListener={handleFormChange}
            />
          </SchedulesDrawer>
        </Grid>
      </Grid>
    </Page>
  );
};

export default Schedules;
